import { useMutation } from '@apollo/client';
import { StartEditingWithTemplateDocument } from './mutation.gql';
export const useStartEditingWithTemplate = () => {
    const [mutate] = useMutation(StartEditingWithTemplateDocument);
    const startEditingWithTemplate = (documentId) => mutate({ variables: { documentId } });
    return { startEditingWithTemplate };
};
